import React, { useState } from 'react'
import { Col, Spinner } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { addItem, resetCart, setAmount } from '../Redux/shoppingCartReducer'
import apiService from '../services/api.service'
import { eventService } from '../services/event.service'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom'
import { useTranslation } from '../hooks/useTranslation'

function BookButtonComponent({ product, getValues, lang, setError, errorsInventoryForm }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const chainId = new URLSearchParams(location.search).get("chainid") || 0;

    const validDailyInventory = () => {
        const hasErrors = Object.keys(errorsInventoryForm).length !== 0;

        if (getValues('dailyInventoryQuantity') && getValues('dailyInventoryDate') && !hasErrors) {
            return true;
        }

        if (!getValues('dailyInventoryQuantity')) {
            setError('dailyInventoryQuantity', { type: 'required', message: t("Choose") + " " + t("Quantity") });
        }

        if (!getValues('dailyInventoryDate')) {
            setError('dailyInventoryDate', { type: 'required', message: t("Choose") + " " + t("Date") });
        }
        return false;
    }

    const addItemToCart = () => {
        dispatch(resetCart())
        dispatch(addItem({ selectedProduct: product }));

        if (product.enableDailyInventory) {
            if (validDailyInventory()) {
                dispatch(setAmount({ selectedProduct: product, qty: getValues('dailyInventoryQuantity') }));
                insertNewSearch(product);
                blockProduct(1);
            }
        } else {
            insertNewSearch(product);
            blockProduct(1);
        }
    };
    const blockProduct = (amount) => {
        setLoading(true);
        sessionStorage.removeItem('productBlockingIdentifier');
        apiService.blockProduct(product.productId, amount).then(
            (response) => {
                let productBlockingIdentifier = response.data;
                if (productBlockingIdentifier) {
                    sessionStorage.setItem('productBlockingIdentifier', productBlockingIdentifier);
                    sessionStorage.setItem('productBlockingIdentifierTime', new Date().toISOString());
                    history.push(`/registrastion?chainid=${chainId}&lang=${lang}`);

                    eventService.addToCart();
                }
                else {
                    alert(t("ProdNotAvail"));
                }
            },
            (error) => {
                alert(t("ProdNotAvail"));
            }
        ).finally(() => setLoading(false));
    }
    const insertNewSearch = (prod) => {
        apiService.insertSearch(prod.productId, null, null, null, true, new Date().toISOString());
        sessionStorage.removeItem('lastOrderNum');
        sessionStorage.removeItem('lastCustomer');
        sessionStorage.removeItem('payerName');
    }
    return (
        <Col md={6} className="book-btn">
            <button
                aria-label={t("Book")}
                className="btn long"
                onClick={(e) => addItemToCart(product)}
                disabled={loading}
            >{loading && <Spinner className="spinner" animation="border" />}
                {t("Book")}
            </button>
        </Col>
    )
}

export default BookButtonComponent